module.exports = __webpack_public_path__ + "static/media/permission-denied-lock.74bba15d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/permission-denied-lock.svg
// module id = 2539
// module chunks = 0